import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61d757a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "full-sidebar d-flex flex-column" }
const _hoisted_2 = {
  key: 0,
  class: "vrt-body"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "vrt-title" }, "Trailer Not Found", -1))
const _hoisted_4 = { class: "vrt-actions" }
const _hoisted_5 = {
  key: 2,
  class: "vrt-body"
}
const _hoisted_6 = {
  key: 0,
  class: "vrt-subtitle"
}
const _hoisted_7 = { class: "vrt-caption" }
const _hoisted_8 = { class: "vrt-actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VirtualRedTagHeader = _resolveComponent("VirtualRedTagHeader")!
  const _component_fbx_button = _resolveComponent("fbx-button")!
  const _component_LoadingModal = _resolveComponent("LoadingModal")!
  const _component_VirtualRedTagTrailerGraphic = _resolveComponent("VirtualRedTagTrailerGraphic")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_VirtualRedTagHeader),
    (_ctx.notFound)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_fbx_button, {
              "button-text": "Go Back",
              theme: "primary",
              onClick: _ctx.navigateToWelcome
            }, null, 8, ["onClick"])
          ])
        ]))
      : (!_ctx.eligibilityResolved)
        ? (_openBlock(), _createBlock(_component_LoadingModal, { key: 1 }))
        : (_ctx.trailer)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("h1", {
                class: _normalizeClass(["vrt-title", { 'vrt-title-prompt': _ctx.isPrompt }])
              }, _toDisplayString(_ctx.title), 3),
              (_ctx.subtitle)
                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.subtitle), 1))
                : _createCommentVNode("", true),
              _createVNode(_component_VirtualRedTagTrailerGraphic, {
                state: _ctx.graphicState,
                company: _ctx.trailer.company
              }, null, 8, ["state", "company"]),
              _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.trailerTypeLabel) + " #" + _toDisplayString(_ctx.trailer.trailerNumber), 1),
              _createElementVNode("div", _hoisted_8, [
                (_ctx.isBlocked || _ctx.isVerified)
                  ? (_openBlock(), _createBlock(_component_fbx_button, {
                      key: 0,
                      "button-text": "Continue to Virtual Red Tag",
                      theme: "primary",
                      disabled: !_ctx.hardEligibilityConfirmed,
                      onClick: _ctx.continueToAssessment
                    }, null, 8, ["disabled", "onClick"]))
                  : (_openBlock(), _createBlock(_component_fbx_button, {
                      key: 1,
                      "button-text": "Yes, continue to Virtual Red Tag",
                      theme: "primary",
                      disabled: !_ctx.hardEligibilityConfirmed,
                      onClick: _ctx.continueToAssessment
                    }, null, 8, ["disabled", "onClick"])),
                (!_ctx.isVerified)
                  ? (_openBlock(), _createBlock(_component_fbx_button, {
                      key: 2,
                      "button-text": "Go Back",
                      theme: "primaryOutline",
                      class: "italic",
                      onClick: _ctx.navigateToWelcome
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              (!_ctx.isVerified)
                ? (_openBlock(), _createBlock(_component_fbx_button, {
                    key: 1,
                    "button-text": "Return to Pointe",
                    theme: "link",
                    class: "italic vrt-return-link",
                    onClick: _ctx.navigateToWelcome
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
  ]))
}